<h4 class="s1"
  *iCms="'header' of content"
text></h4>

@if (content?.texts?.length) {
  @for (item of content?.texts; track item) {
    <div class="m-t-3 m-t-4-s m-t-4-m"
      >
      <a class="block p2"
      [routerLink]="item.link">{{item.text}}</a>
    </div>
  }
}
